import { Switch, Space, Typography } from 'antd'
import { Moon, Sun } from 'lucide-react'
import { useUIStore } from '@/store/uiStore'
import { t } from '@/config/translations'

const { Text } = Typography

export function ThemeToggle() {
  const { isDarkMode, toggleTheme } = useUIStore()

  return (
    <div style={{ padding: '16px', borderTop: '1px solid #f0f0f0' }}>
      <Space style={{ width: '100%', justifyContent: 'space-between' }}>
        <Space size={8}>
          {isDarkMode ? <Moon size={16} /> : <Sun size={16} />}
          <Text strong>{t(isDarkMode ? 'theme_dark' : 'theme_light')}</Text>
        </Space>
        <Switch checked={isDarkMode} onChange={toggleTheme} />
      </Space>
    </div>
  )
}
